import React from 'react';
import styles from './Footer.css';

const Footer = () => {
  return (
    <footer className={styles.Footer}>
      <p>&copy;Ben Beekman, 2023</p>
    </footer>
  );
};

export default Footer;
